/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-07-02 17:53:42
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Notification from './notifications/notification';
import { getShop } from 'src/helpers';
import { getDisplayNotifications } from 'src/helpers/dashboard-helper';

import * as notificationAction from 'actions/dashboard/notification-actions';

type Props = {
  dismissNotification: () => void,
  notifications: Array<Object>,
  subscription: Object
};

class TopNotifications extends Component<Props> {
  renderNotification(notification) {
    const { type } = notification;
    const { dismissNotification } = this.props;

    const component = {
      info: 'info',
      warn: 'warning',
      error: 'critical',
      success: 'success'
    };

    return component[type] ? (
      <Notification
        status={component[type]}
        notification={notification}
        onDismiss={dismissNotification}
      />
    ) : (
      ''
    );
  }

  render() {
    const { notifications } = this.props;

    // Determine blocks to be rendered
    const displayNotifications = getDisplayNotifications(notifications, getShop());

    // Verify and remove exceeded plan notification
    const filteredNotifications = this.verifyNotificationForExceededPlan(displayNotifications);

    return (
      <React.Fragment>
        {filteredNotifications.map((notification, index) => {
          return (
            <React.Fragment key={'notification-' + index}>
              {this.renderNotification(notification)}{' '}
            </React.Fragment>
          );
        })}
      </React.Fragment>
    );
  }

  // Verify subscription status and remove notification if needed
  verifyNotificationForExceededPlan = notifications => {
    let { exceededPlan, exceededPlanAt, subscription } = this.props;

    // Get subscription status
    const { status } = subscription;

    let filteredNotifications = notifications;

    // Remove exceede plan notif if the store is subscribed
    if (
      ['subscribed', 'specialDiscountExpiredSoon', 'specialDiscountExpired'].includes(status) &&
      !exceededPlan &&
      exceededPlanAt > 0
    ) {
      // This is post process that helps to remove notification for exceeded plan
      // Because the conditional function for filtering notification is limited by tenant app info
      filteredNotifications = _.filter(filteredNotifications, notification => {
        return notification.title !== '[Important] Exceeded subscription plan';
      });
    }

    return filteredNotifications;
  };
}

const mapStateToProps = (state, props) => {
  return {
    notifications: _.get(state.notifications, 'topList', []),
    exceededPlan: _.get(state.oauth.tenantApp, 'exceededPlan'),
    exceededPlanAt: _.get(state.oauth.tenantApp, 'exceededPlanAt'),
    subscription: _.get(state.oauth, 'subscription', {})
  };
};

const mapDispatchToProps = dispatch => ({
  dismissNotification: notificationId =>
    dispatch(notificationAction.dismissNotification(notificationId))
});

export default connect(mapStateToProps, mapDispatchToProps)(TopNotifications);
